import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { scrubSentryEvent } from '@ballerine/sentry-scrubbing';

import { env } from '@/common/env/env';

export const initializeSentry = () => {
  if (!env.VITE_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],

    // Single source of truth for PII scrubbing, shared with every other surface.
    beforeSend: scrubSentryEvent,
    beforeSendTransaction: scrubSentryEvent,

    tracesSampleRate: 1.0,

    ...(env.VITE_SENTRY_PROPAGATION_TARGET && {
      tracePropagationTargets: [env.VITE_SENTRY_PROPAGATION_TARGET],
    }),

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
};
